import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive } from 'vue';
import { message } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { create_require_info, update_require_info } from '@/api/mjstore-model';
import bus from '@/utils/bus';
const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const event_bus = bus;
export const event_obj = mitt();
export const btn_list = [
  {
    name: '编辑',
    type: 'dropdown',
    clazz: 'primary',
    cb: (data: any) => {
      // const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '编辑基础信息',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'input',
              name: 'content',
              label: '诉求内容',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写诉求内容',
            },
            {
              type: 'input',
              name: 'solution',
              label: '解决方案',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写解决方案',
            },
            {
              type: 'input',
              name: 'code',
              label: '诉求编号',
              disabled: true,
              allowClear: false,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写诉求编号',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: true,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {
            content: [{ required: true, message: '请填诉求内容' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            require_info_id: data.id,
            content: data.content,
            solution: data.solution,
            code: data.code,
            shop_id: data.shop_id,
            staff_id: data.staff_id,
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            update_require_info(payload)
              .then(() => {
                message.success('编辑诉求信息成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '计划',
    type: 'dropdown',
    clazz: 'primary',
    cb: (data: any) => {
      event_bus.emit('refresh_planinfo', { data: data, title: '计划', type: 'mjstore-planinfo1' });
    },
  },
  {
    name: '回访',
    type: 'dropdown',
    clazz: 'primary',
    cb: (data: any) => {
      event_bus.emit('refresh_feedbackinfo', {
        data: data,
        title: '回访',
        type: 'mjstore-feedbackinfo1',
      });
    },
  },
  {
    name: '下单',
    type: 'dropdown',
    clazz: 'primary',
    cb: (data: any) => {
      event_bus.emit('refresh_orderrecord', {
        data: data,
        title: '下单',
        type: 'mjstore-orderrecord1',
      });
    },
  },
  {
    name: '购卡',
    type: 'dropdown',
    clazz: 'primary',
    cb: (data: any) => {
      event_bus.emit('refresh_cardrecord', {
        data: data,
        title: '购卡',
        type: 'mjstore-cardrecord1',
      });
    },
  },
  {
    name: '套餐',
    type: 'dropdown',
    clazz: 'primary',
    cb: (data: any) => {
      event_bus.emit('refresh_setrecord', { data: data, title: '套餐', type: 'mjstore-setrecord' });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [
  {
    name: '新建',
    clazz: 'primary',
    icon: 'plus-outlined',
    cb: (data: any) => {
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        loading: false,
        visible: true,
        title: '新建诉求',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'input',
              name: 'content',
              label: '诉求内容',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写诉求内容',
            },
            {
              type: 'input',
              name: 'solution',
              label: '解决方案',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写解决方案',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '创建日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: true,
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              placeholder: '请填写创建日期',
            },
          ],
          rules: {
            content: [{ required: true, message: '请填诉求内容' }],
            date: [{ required: true, message: '请填创建日期' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            customer_id: data.customer_id,
            solution: null,
            content: null,
            shop_id: current_shop?.id,
            staff_id: null,
            code: null,
            date: null,
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            create_require_info(payload)
              .then(() => {
                message.success('新建诉求信息成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
